<template>
  <svg
    :class="size"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.1667 8.49984C31.1667 6.93503 32.4353 5.6665 34.0001 5.6665C35.5649 5.6665 36.8334 6.93503 36.8334 8.49984V14.1665C36.8334 15.7313 35.5649 16.9998 34.0001 16.9998C32.4353 16.9998 31.1667 15.7313 31.1667 14.1665V8.49984ZM53.8334 31.1665H59.5001C61.0649 31.1665 62.3334 32.435 62.3334 33.9998C62.3334 35.5646 61.0649 36.8332 59.5001 36.8332H53.8334C52.2686 36.8332 51.0001 35.5646 51.0001 33.9998C51.0001 32.435 52.2686 31.1665 53.8334 31.1665ZM48.1712 23.0631C48.9007 23.0602 49.601 22.7761 50.1262 22.2698L54.2062 18.3315C55.2882 17.201 55.2488 15.4075 54.1183 14.3255C53.0896 13.3409 51.4899 13.2729 50.3812 14.1665L46.3012 18.1898C45.2027 19.2949 45.2027 21.0797 46.3012 22.1848C46.7918 22.7025 47.4595 23.0162 48.1712 23.0631ZM31.1667 53.8332C31.1667 52.2684 32.4353 50.9998 34.0001 50.9998C35.5649 50.9998 36.8334 52.2684 36.8334 53.8332V59.4998C36.8334 61.0646 35.5649 62.3332 34.0001 62.3332C32.4353 62.3332 31.1667 61.0646 31.1667 59.4998V53.8332ZM50.2351 45.7298C49.1084 44.6423 47.3135 44.674 46.2259 45.8007C45.1384 46.9273 45.1701 48.7223 46.2967 49.8098L50.3767 53.8332C50.902 54.3394 51.6022 54.6236 52.3317 54.6265C53.0988 54.631 53.8348 54.3243 54.3717 53.7765C55.4828 52.6746 55.4901 50.8806 54.3882 49.7696L54.3717 49.7532L50.2351 45.7298ZM13.685 49.6677L17.765 45.7294V45.8144C18.8917 44.7269 20.6866 44.7586 21.7742 45.8852C22.8617 47.0119 22.83 48.8069 21.7034 49.8944L17.6234 53.8327C17.0995 54.2948 16.4235 54.547 15.725 54.5411C14.958 54.5455 14.2219 54.2389 13.685 53.6911L13.6686 53.6746C12.5667 52.5636 12.574 50.7697 13.685 49.6677Z"
      :fill="$primaryColor"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9998 34.0003C16.9998 32.4355 15.7313 31.167 14.1665 31.167H8.49984V31.167C6.93503 31.167 5.6665 32.4355 5.6665 34.0003C5.6665 35.5651 6.93503 36.8337 8.49984 36.8337H14.1665C15.7313 36.8337 16.9998 35.5651 16.9998 34.0003Z"
      fill="#F37638"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.6185 14.1664V14.1664C16.4683 13.0789 14.6543 13.1296 13.5668 14.2797C12.4793 15.4299 12.53 17.2439 13.6801 18.3314L17.7601 22.2697C18.3133 22.8039 19.0599 23.0903 19.8285 23.0631C20.5997 23.0601 21.3363 22.7429 21.8685 22.1847C22.967 21.0796 22.967 19.2948 21.8685 18.1897L17.6185 14.1664Z"
      fill="#F37638"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'md:h-20 md:w-20 h-14 w-14"'
    }
  }
}
</script>
